import React from "react";
import useAddMemberHook from "../../views/Messaging/List/component/AddMember/AddMember.hook";
import noDataImg from "../../assets/img/ic_search_empty@2x.png";
import { Search } from "@material-ui/icons";
import styles from "./Style.module.css";
import ChatAvatarItem from "./ChatAvatarItem.component";
import {
  CircularProgress,
  TablePagination,
} from "@material-ui/core";

function StartNewChat({ onSelectUser, onBack }) {
  const {
    handleValueChange,
    selected,
    setSelected,
    currentPage,
    currentData,
    data,
    allData,
    handlePageChange,
    loading,
  } = useAddMemberHook({});

  return (
    <div style={{ display: "flex", flexDirection: "column", height: "100%" }}>
      <div className={styles.newChatHeader} onClick={onBack}>
        <span style={{ fontSize: "1rem" }}>←</span> Back to conversations
      </div>
      <div className={styles.searchWrap}>
        <div style={{ position: "relative", display: "flex", alignItems: "center" }}>
          <input
            type="text"
            className={styles.searchInput}
            placeholder="Search employee name or code..."
            onChange={(e) => handleValueChange(e.target.value)}
          />
          <Search style={{ position: "absolute", right: "12px", fontSize: "18px", color: "#656d76", pointerEvents: "none" }} />
        </div>
      </div>

      <div className={styles.chatList} style={{ flex: 1, overflowY: "auto" }}>
        {loading ? (
          <div className={styles.emptyState}>
            <CircularProgress size={24} style={{ color: "#2896e9" }} />
          </div>
        ) : currentData?.length > 0 ? (
          currentData.map((val) => (
            <div
              key={val?.id}
              className={styles.chatListItem}
              style={{
                backgroundColor: selected?.id === val?.id ? "#ecf7ff" : undefined,
              }}
              onClick={() => {
                setSelected(val);
                onSelectUser(val);
              }}
            >
              <div className={styles.chatItemLeft}>
                <ChatAvatarItem
                  image={val?.image}
                  initials={val?.initials}
                  label={val?.name}
                  size={38}
                />
                <div className={styles.chatInfo}>
                  <div className={styles.chatTitle}>{val?.name}</div>
                  <div className={styles.chatDes}>{val?.code || val?.designation?.name || "Employee"}</div>
                </div>
              </div>
              <button
                className={styles.startBtn}
                onClick={(e) => {
                  e.stopPropagation();
                  onSelectUser(val);
                }}
              >
                Chat
              </button>
            </div>
          ))
        ) : (
          <div className={styles.emptyState}>
            <img src={noDataImg} height={90} alt="No results" style={{ opacity: 0.7 }} />
            <b style={{ color: "#1f2328" }}>No Employees Found</b>
            <span>No matching records available</span>
          </div>
        )}
      </div>

      {allData?.length > 0 && (
        <div style={{ borderTop: "1px solid #e0e0e0", background: "#ffffff" }}>
          <TablePagination
            rowsPerPageOptions={[]}
            component="div"
            count={data?.length || 0}
            rowsPerPage={10}
            page={currentPage - 1}
            onPageChange={(event, newPage) => {
              handlePageChange(newPage);
            }}
            style={{ overflow: "hidden", minHeight: "42px" }}
          />
        </div>
      )}
    </div>
  );
}

export default StartNewChat;
